import axios from "axios";

export const add = (paragraph) => axios.post("paragraphs", paragraph);
export const update = (paragraph) => axios.post(`paragraphs/${paragraph.get("id")}`, paragraph);
export const remove = (id) => axios.delete(`paragraphs/${id}`);
